<template>
    <v-app id="list1">
        <v-main>
            <v-container fluid class="ml-8">
                <v-form @submit="buildReport">
                    <v-row dense >                  
                        <v-col cols="2">
                            <select_real_test :selected_type="realTestSelected" field="realTestSelected" label="Type" :isClearable="true"
                                @updateData="updateData" :canSelectAll="true" :isMultiple="true" :localStorageItem="localStorageItemType" />
                        </v-col>    
                    </v-row>
                    <v-row dense>    
                        <v-col cols="4">
                            <select_hust_codes :selected_husttypes="hustCodesSelected" field="hustCodesSelected" 
                                :isClearable="true" @updateData="updateData" :localStorageItem="localStorageItemHust" :visibleChips="6" />
                        </v-col>          
                    </v-row>
                    <v-row dense>
                        <v-col cols="2">
                            <date_picker label="Booking date from"                                 
                                :date="param.booking_van_dat"
                                field="booking_van_dat" 
                                hint="Only enter a date if applicable" 
                                icon="mdi-calendar-month-outline"
                                :manual="false" 
                                @updateData="updateDate"/> 
                        </v-col>
                        <v-col cols="2" class="pl-4">
                            <date_picker label="Booking date until"                                 
                                :date="param.booking_tm_dat"
                                field="booking_tm_dat" 
                                hint="Only enter a date if applicable" 
                                icon="mdi-calendar-month-outline"
                                :manual="false" 
                                @updateData="updateDate"/> 
                        </v-col>
                    </v-row>  
                    <v-row dense>
                        <v-col cols="2">
                            <date_picker label="Arrival date from"                                 
                                :date="param.arrival_van_dat"
                                field="arrival_van_dat" 
                                hint="Only enter a date if applicable" 
                                icon="mdi-calendar-month-outline"
                                :manual="false" 
                                @updateData="updateDate"/> 
                        </v-col>
                        <v-col cols="2"  class="pl-4">
                            <date_picker label="Arrival date until"                                 
                                :date="param.arrival_tm_dat"
                                field="arrival_tm_dat" 
                                hint="Only enter a date if applicable" 
                                icon="mdi-calendar-month-outline"
                                :manual="false" 
                                @updateData="updateDate"/> 
                        </v-col>
                    </v-row>  
                    <v-row dense>
                        <v-col cols="2">
                            <date_picker label="Departure date from"                                 
                                :date="param.departure_van_dat"
                                field="departure_van_dat" 
                                hint="Only enter a date if applicable" 
                                icon="mdi-calendar-month-outline"
                                :manual="false" 
                                @updateData="updateDate"/> 
                        </v-col>
                        <v-col cols="2"  class="pl-4">
                            <date_picker label="Departure date until"                                 
                                :date="param.departure_tm_dat"
                                field="departure_tm_dat" 
                                hint="Only enter a date if applicable" 
                                icon="mdi-calendar-month-outline"
                                :manual="false" 
                                @updateData="updateDate"/> 
                        </v-col>        
                    </v-row> 
                    <v-row dense class="mt-2">
                        <v-col cols="4">
                            <select_eign :isClearable="true" field="eign_code" label="Owner (+caretaker)" @updateData="updateData"/>
                        </v-col>    
                    </v-row>  
                    <v-row>    
                        <v-col cols="1">
                            <v-btn class="primary" small :disabled="results" color="success" @click="buildReport">
                                <v-icon medium class="mr-2">mdi-microsoft-excel</v-icon>
                                <span class="pr-1">Create excel</span>
                            </v-btn>            
                        </v-col> 
                    </v-row>
                </v-form>
            </v-container>
        </v-main>
        <showProgress ref="showProgress"></showProgress>
        <navBar title="Ares - Main menu" :home="true" :accolist="false" type="main"/>
    </v-app>
</template>

<script>
    import navBar from "@/components/ui/navbars/navbar.vue";
    import select_hust_codes from "@/components/ui/selectors/select_hust_codes.vue"
    import select_real_test from "@/components/ui/selectors/select_real_test.vue"  
    import date_picker from '@/components/ui/date_picker.vue';
    import select_eign from "@/components/ui/selectors/select_eign.vue";
    import showProgress from "@/components/showProgress.vue";

    export default {
        components: {
            navBar,
            showProgress,
            select_hust_codes,
            select_real_test,
            date_picker,
            select_eign
        },
        data() {
            return {
                localStorageItemHust: 'search.heho.list1.hustcodes',
                localStorageItemType: 'search.heho.list1.typecodes',
                hustCodesSelected: [],
                hustCodes: [],
                realTestSelected: [],
                realTest: [],
                items: [],
                results: false,
                eign_code: '',
                param: {
                    booking_van_dat: null,
                    booking_tm_dat: null,
                    arrival_van_dat: null,
                    arrival_tm_dat: null,     
                    departure_van_dat: null,
                    departure_tm_dat: null,                
                }
            }
        },
        methods: {
            buildReport() {
                this.results = true;
                this.$refs.showProgress.open();      
                this.$axios.post("ares/json/ares/heho/ovrz/hehoExcelExportList1v2.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "hehoExcelExportList1"
                    },
                    hehoExcelExportList1: {
                        hust_codes: this.hustCodesSelected,
                        real_test: this.realTestSelected,
                        booking_van_dat: this.param.booking_van_dat,
                        booking_tm_dat: this.param.booking_tm_dat,
                        arrival_van_dat: this.param.arrival_van_dat,
                        arrival_tm_dat: this.param.arrival_tm_dat,
                        departure_van_dat: this.param.departure_van_dat,
                        departure_tm_dat: this.param.departure_tm_dat,
                        eign_code: this.eign_code
                    }
                }).then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                    } else {
                        // bij afgerond overzicht stand bewaren, die wordt in component(en) opgevraagd 
                        localStorage.setItem(this.localStorageItemHust, this.hustCodesSelected);
                        localStorage.setItem(this.localStorageItemBedr, this.bedrCodesSelected);
                        localStorage.setItem(this.localStorageItemType, this.realTestSelected);

                        this.items = res.data.hehoExcelExportList1;
                        this.$refs.showProgress.close();
                        this.results = false;
                        window.open(this.items.filename, '_blank');
                    }
                })
            },
            updateData(data) {
                this[data.field] = data.value;
            },
            updateDate(data) {
                this.param[data.field] = data.value;
            },    
        }
    };
</script> 
